<template>
  <div class="zhanwei4"></div>
  <div class="next">
    <h1 style="font-size: 1.9vh">{{ $t("Content.contentEdit") }}</h1>
    <div class="btns">
      <el-button
        style="background: #4f4f4f; color: #fff"
        size="large"
        @click="value == '自定义地图' ? saveContent() : saveContent2()"
      >
        {{ $t("Content.save") }}
      </el-button>
    </div>
  </div>
  <div class="zhanwei4"></div>
  <el-select
    v-model="value"
    placeholder="Select"
    size="large"
    style="width: 240px; margin-left: 10px; margin-top: 20px"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>

  <div class="contentSetting">
    <el-row>
      <el-col :xs="24" :sm="12">
        <div class="">
          <div class="content add">
            <el-button
              type="primary"
              size="large"
              color="#000"
              @click="addLevel"
              >{{ $t("Content.addLevel") }}</el-button
            >
          </div>
          <div
            v-draggable="[
              list2,
              {
                animation: 150,
                onUpdate,
                onStart,
              },
            ]"
          >
            <div class="content" v-for="item in list2" :key="item.id">
              {{ item.id }}.
              {{ item.name }}
              <el-icon size="24" class="edit" @click="toEditLevel(item.levelId)"
                ><EditPen
              /></el-icon>

              <el-icon
                size="24"
                class="delete"
                @click="deleteLevel(item.levelId)"
                ><DeleteFilled
              /></el-icon>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12">
        <div class="contentSetting_right">
          <div class="gaodeMap">
            <div v-if="value == '高德地图'">
              <MapContainer
                @changePos="changePos"
                :long="long"
                :lat="lat"
              ></MapContainer>
            </div>
            <div class="map2" v-if="value == '自定义地图'">
              <Cavan ref="Cav" :imgUrl="CavImg"></Cavan>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import { Right, DeleteFilled, EditPen } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { vDraggable } from "vue-draggable-plus";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { toRaw } from "@vue/reactivity";
import MapContainer from "@/components/content/MapContainer.vue";
import Cavan from "@/components/canvans/canvans.vue";
import router from "@/router";
import { Props } from "element-plus/es/components/select-v2/src/useProps";
export default defineComponent({
  name: "App",
  directives: {
    draggable: vDraggable,
  },
  data(): any {
    return {
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: 3,
        time: 1,
        resource: "",
        desc: "",
      },
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      gameLevelId: "",
      gameId: "",
    };
  },
  components: {
    Right,
    EditPen,
    DeleteFilled,
    MapContainer,
    Cavan,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
  },
  watch: {
    counter(newVal: number, oldVal: number) {
      console.log(`Counter changed from ${oldVal} to ${newVal}`);
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
  },

  setup(props: Props, ctx) {
    const store = useStore();
    const route = useRoute();
    const List = store.state.game.levels;
    const list2 = ref(List);
    const gameLevelId = ref(""); // 正确定义 gameLevelId 的 ref
    let long = ref(0);
    let lat = ref(0);
    const instance = getCurrentInstance();
    let value = ref("自定义地图");
    let options = ref([
      {
        value: "高德地图",
        label: "高德地图",
      },
      {
        value: "自定义地图",
        label: "自定义地图",
      },
    ]);

    let CavImg = ref("");

    const gameId = route.params.id;
    onMounted(() => {
      if (gameId != "0") {
        const game = store.state.game.games.find((item: any) => {
          return item.id == gameId;
        });

        if (game) {
          gameLevelId.value = game.gameLevelId; // 正确设置 gameLevelId 的值
          long.value = game.longitude;
          lat.value = game.latitude;
          value.value = game.mapSelect;

          CavImg.value = game.customizeMap;

          if (game.mapSelect === "自定义地图" && game.customizeMap) {
            const canvans: any = instance?.proxy?.$refs["Cav"];
            if (canvans) {
              canvans.customeMap2(game.customizeMap); // 调用子组件的方法保存图片
            }
          }
        }
      }
    });

    function onStart() {}

    async function onUpdate() {
      let sortLevel = "";
      const items = toRaw(list2.value);

      // 确保 for 循环是同步完成的
      for (let index = 0; index < items.length; index++) {
        const item = items[index];
        if (index === 0) {
          sortLevel = item.levelId;
        } else {
          sortLevel += "," + item.levelId;
        }
      }

      try {
        // 确保 dispatch 调用完成后再继续
        await store.dispatch("game/setGameSort", {
          gameLevelId: gameLevelId.value,
          sortLevel,
        });
        ElMessage.success({
          message: "修改成功",
        });
      } catch (error) {
        ElMessage.error({
          message: "修改失败",
        });
      }
    }

    function toEditLevel(levelId: string) {
      if (this.levelId != undefined || this.levelId != "") {
        router.push("/edit/" + gameId + "/" + levelId);
      }
    }

    function deleteLevel(LevelId: string) {
      ElMessageBox.confirm(this.$t("Content.deleteInfo"), "warning", {
        confirmButtonText: this.$t("Content.confirm"),
        cancelButtonText: this.$t("Content.channel"),
        draggable: true,
        type: "warning",
      })
        .then(() => {
          store
            .dispatch("game/delLevel", {
              ids: [LevelId],
              gameLevelId: gameLevelId.value,
              gameId: gameId,
            })
            .then((res: any) => {
              if (res === 1) {
                list2.value = list2.value.filter(
                  (item: any) => item.levelId !== LevelId
                );
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    }

    function addLevel() {
      const a: number = list2.value.length + 1;
      const title = "关卡" + a;

      store
        .dispatch("game/add2Level", {
          levelTitle: title,
          gameLevelId: gameLevelId.value,
          gameId: gameId,
        })
        .then((res: any) => {
          const aa = {
            id: a,
            levelId: res.id,
            name: res.levelTitle,
          };

          list2.value.push(aa);
        })
        .catch((err: never) => {});
    }

    function changePos(value1: number, value2: number) {
      store
        .dispatch("game/UpdateGamePos", {
          gameId: gameId,
          value1: value1,
          value2: value2,
        })
        .then((res: any) => {})
        .catch(() => {});
    }

    const saveContent = () => {
      const canvans: any = instance?.proxy?.$refs["Cav"];
      if (canvans) {
        canvans.saveImage(gameId); // 调用子组件的方法保存图片
      }
    };
    const saveContent2 = () => {
      const game = store.state.game.games.find((item: any) => {
        return item.id == gameId;
      });

      if (game.mapSelect != "高德地图") {
        store
          .dispatch("game/UpdateGameMap", {
            gameId: gameId,
            mapSelect: "高德地图",
          })
          .then((res: any) => {});
      }
    };

    return {
      list2,
      onStart,
      onUpdate,
      gameLevelId,
      gameId,
      long,
      lat,
      toEditLevel,
      deleteLevel,
      addLevel,
      changePos,
      value,
      options,
      saveContent,
      saveContent2,
      CavImg,
    };
  },
});
</script>

<style lang="less" scoped>
@import "@/static/less/content.less";

.gaodeMap {
  width: 80vw;
  height: 80vw;

  box-sizing: border-box;
  max-width: 600px;
}

.map2 {
  width: 50vw;
  height: 50vw;

  max-width: 700px;
  max-height: 700px;
  margin-left: 10px;
}
</style>
